import React from "react";
import NotificationLayout from "../../../sections/CustomerDashboard/Inbox/Notifications/NotificationLayout";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import {
  AdminPageTitle,
  AdminSupportingText,
} from "../../../sections/AdminDashboard/shared/adminUx";

import {
  CUSTOMER_CENTERED_PAGE_TITLE_CLASS,
} from "../../../sections/CustomerDashboard/shared/customerLayoutSpec";

const CustNotifications = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${CUSTOMER_CENTERED_PAGE_TITLE_CLASS}`}>
        Alerts and notifications
      </AdminPageTitle>

      <div className="mx-auto min-h-screen">
        <NotificationLayout />
        <AdminSupportingText className="mt-20 text-center text-mediumgray block">
          You&apos;ve reached the end of the list.
        </AdminSupportingText>
      </div>
    </DashboardMainContainer>
  );
};

export default CustNotifications;
